<template>
  <paginated-panel
    :paginator="paginator"
    action="safe/getPaginator"
    :loading="$store.state.safe.loading"
    :plural-name="i18n.invoice.filters.refills"
  >
    <template v-slot:header>
      <header class="flex justify-between items-center py-2">
        <h2 class="text-xl py-2" v-text="i18n.title" />
        <div
          class="flex text-xl items-center text-gray-700 relative m-0"
          v-if="$route.name === 'invoice.index'"
        >
          <new-refill-button />
        </div>
      </header>
    </template>
    <template v-slot:item="{ item }">
      <invoice :data="item" />
    </template>
    <template v-slot:empty>
      <span v-text="i18n.no_refill" />
    </template>
  </paginated-panel>
</template>

<script>
import Invoice from "./Invoice";
import PaginatedPanel from "../Design/PaginatedPanel";
import NewRefillButton from "../Menu/NewRefill";

export default {
  components: { Invoice, PaginatedPanel, NewRefillButton },
  computed: {
    paginator() {
      return this.$store.state.safe.invoices.paginator;
    },

    i18n() {
      return this.$store.state.safe.i18n;
    },
  },
  mounted() {
    this.$store.dispatch("safe/getPaginator");
  },
};
</script>
